import { CheckOutlined, CloseOutlined, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { ButtonProps, Modal, ModalFuncProps } from 'antd';
import React, { useCallback, useMemo } from 'react';

import { AsyncSinapseResponseStatus } from '../api';
import { SinapseButton } from '../components/SinapseButton';
import { SparkIcon } from '../icons/spark';

export const GenerateOpportunityDescriptionButton: React.FC<SinapseBtnMainProps> = (props) => {
  const modalProps = {
    title: 'Sobrescrever a descrição atual?',
    content:
      'Ao gerar a descrição automática, a descrição atual será substituída pela nova. Você tem certeza que deseja prosseguir? ',
    okText: 'Sim',
    cancelText: 'Não',
  };

  return (
    <TextOverwriteWithAIGenerated
      confirmOverwrite
      {...props}
      confirmProps={modalProps}
      btnContent="Gerar descrição da vaga"
    />
  );
};

export type SinapseBtnMainProps = {
  discartResponseText?: () => void;
  processText?: () => void;
  responseTextStatus: AsyncSinapseResponseStatus['status'] | '';
  textValue: string;
  isTextEmpty?: (t: string) => boolean;
  btnProps?: ButtonProps;
};
type ConfirmProps = Pick<ModalFuncProps, 'title' | 'content' | 'okText' | 'cancelText'>;

export const TextOverwriteWithAIGenerated: React.FC<
  SinapseBtnMainProps & {
    confirmOverwrite: boolean;
    confirmProps: ConfirmProps;
    btnContent: React.ReactNode;
  }
> = ({
  discartResponseText,
  processText,
  responseTextStatus = '',
  textValue = '',
  isTextEmpty = (t: string) => !t || t.trim().length === 0,
  confirmOverwrite,
  confirmProps,
  btnContent,
  btnProps = {},
}) => {
  const isLoadingResponse = useMemo(() => responseTextStatus === 'pending', [responseTextStatus]);

  const handleCancel = useCallback(() => {
    if (discartResponseText) {
      discartResponseText();
    }
  }, [discartResponseText]);

  const confirm = useCallback(() => {
    if (confirmOverwrite) {
      Modal.confirm({
        ...confirmProps,
        onCancel: handleCancel,
        cancelButtonProps: { icon: <CloseOutlined />, danger: true },
        onOk: processText,
        okButtonProps: {
          icon: responseTextStatus !== 'failed' ? <CheckOutlined /> : <ReloadOutlined />,
        },
      });
    }
  }, [confirmOverwrite, confirmProps, handleCancel, processText, responseTextStatus]);

  const handleGenerate = useCallback(() => {
    if (isLoadingResponse) return;
    if (isTextEmpty(textValue) || !confirmOverwrite) {
      if (processText) {
        processText();
      }
    } else confirm();
  }, [confirm, confirmOverwrite, isLoadingResponse, isTextEmpty, processText, textValue]);

  return (
    <SinapseButton
      type="primary"
      shape="round"
      {...btnProps}
      disabled={isLoadingResponse || btnProps.disabled}
      onClick={handleGenerate}
      size="large"
      icon={
        !isLoadingResponse ? (
          <SparkIcon animate={false} style={{ fontSize: '1em' }} />
        ) : (
          <LoadingOutlined />
        )
      }
    >
      {btnContent}
    </SinapseButton>
  );
};
